import { makeRequest } from 'utils/requestLogger';

// When the request fails
const failed = (error) => {
  console.log('pin submission failed', error);
};

export default (submissionID) => {
  makeRequest('put', `/api/submissions/${submissionID}/toggle-pin`)
    .then(() => {})
    .catch((error) => {
      failed(error);
    });
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/submission/pinSubmission.js